<i18n src="./../../i18n/empty_basket.json"></i18n>

<template>
    <div class="container-fluid mt-subpage-section m-0 p-0">
        <div class="container-fluid m-0 p-0">
            <div class="lazy container-fluid">

                <div class="container">
                    <div class="content-container p-3 pt-5 text-center">
                        <img data-src="/assets/mt-empty-cart.png" alt="empty" class="lazy pt-5">
                        <div class="row">
                            <div class="col pt-2 pl-4">
                                <span class="pt-2 pb-0 mt-f-bold" v-text="$t('emptyBasket')" />
                                <br>
                                <router-link :to="{name: 'offer'}" v-text="$t('goToOffer')" />
                            </div>
                        </div>
                    </div>

                    <main-footer/>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import MainFooter from "@/components/commons/MainFooter";
    import LazyLoad from "vanilla-lazyload";

    var lazyLoadInstance = new LazyLoad({
        elements_selector: ".lazy"
    });

    export default {
        name: "EmptyBasket",
        components: {MainFooter},
        data () {
            return {
            }
        },
        mounted() {
            this.$nextTick(() => {
                lazyLoadInstance.update()
            })
        }
    }
</script>

<style scoped>
</style>